module.exports = __webpack_public_path__ + "static/media/Paysages.337d9240.webp";